<template>
  <mdb-modal size="lg" scrollable>
    <mdb-modal-header :close="false" class="primary-color text-white text-center">
      <h5>{{ label }}</h5>
    </mdb-modal-header>
    <mdb-modal-body>
      <mdb-input id="message-subject" type="text" v-model="subject" label="Subject" v-if="requireSubject"/>
      <mdb-input id="message-body" :rows="10" noWrapper type="textarea" v-model="text" :label="bodyPlaceholder"/>
      <mdb-input id="post-admin-checkbox" label="Post as Admin?" type="checkbox"
                 v-model="postAsAdmin" v-if="currentUser.isAdmin"/>
      <div v-if="allowFileUpload && !showFileUpload">
        <mdb-btn size="sm" rounded @click="showFileUpload=true" icon="image">Attach Image(s)</mdb-btn>
      </div>
      <mdb-file-upload v-if="allowFileUpload && showFileUpload" :files="files" multiple/>
      <mdb-btn @click="save" icon="paper-plane" :disabled="!text || (!subject&&requireSubject)">{{ buttonLabel }}
      </mdb-btn>
      <mdb-btn @click="cancel" color="danger" icon="times-circle">Cancel</mdb-btn>
      <div>
        <small>You can format your messages with <i>Markdown</i>.
          <a href="https://www.markdownguide.org/cheat-sheet" target="_blank">Learn more here.
            <mdb-icon icon="external-link"/>
          </a>
        </small>
      </div>
    </mdb-modal-body>
  </mdb-modal>

</template>
<script>
import mdbFileUpload from 'mdbvue-file-upload'
import {mdbBtn, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalHeader} from 'mdbvue';

export default {
  name: 'messageCreate',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbIcon,
    mdbBtn,
    mdbInput,
    mdbFileUpload
  },
  props: {
    label: {
      type: String,
      default: "Your Comment"
    },
    originalText: {
      type: String,
      default: null
    },
    allowFileUpload: {
      type: Boolean,
      default: false
    },
    originalSubject: {
      type: String,
      default: null
    },
    requireSubject: {
      type: Boolean,
      default: false
    },
    bodyPlaceholder: {
      type: String,
      default: "Say something nice..."
    },
    buttonLabel: {
      type: String,
      default: "Send"
    }
  },
  data() {
    return {
      text: "",
      subject: "",
      postAsAdmin: false,
      showFileUpload: false,
      files: []
    }
  },
  mounted() {
    let el
    if (this.requireSubject) el = document.getElementById("message-subject")
    else el = document.getElementById("message-body")
    if (el) el.focus()
    if (this.originalText) this.text = this.originalText
    if (this.originalSubject) this.subject = this.originalSubject
  },
  computed: {
    currentUser() {
      return this.$store.state.userDetails
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel")
    },
    save() {
      this.$emit("save", {text: this.text, subject: this.subject, postAsAdmin: this.postAsAdmin, files: this.files})
    }
  }

};
</script>
